// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UsersPopover__container-fd1e8f {
  max-width: 160px;
  position: relative;
  width: fit-content;
  background-color: var(--addition-110);
  border-radius: 8px;
}

.UsersPopover__list-with-count-f8eafe {
  padding-bottom: 0;
}

.UsersPopover__more-a0f0be {
  font: var(--font-caption-4);
  color: var(--addition-50);
  opacity: 0.6;
  cursor: pointer;
}

.UsersPopover__more-a0f0be:hover {
  opacity: 0.7;
}

.UsersPopover__more-a0f0be:active {
  opacity: 1;
}

@supports (display: block) {
  .UsersPopover__more-a0f0be:focus-visible {
    opacity: 0.7;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UsersPopover/UsersPopover.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;AACF","sourcesContent":[".container {\n  max-width: 160px;\n  position: relative;\n  width: fit-content;\n  background-color: var(--addition-110);\n  border-radius: 8px;\n}\n\n.list-with-count {\n  padding-bottom: 0;\n}\n\n.more {\n  font: var(--font-caption-4);\n  color: var(--addition-50);\n  opacity: 0.6;\n  cursor: pointer;\n}\n\n.more:hover {\n  opacity: 0.7;\n}\n\n.more:active {\n  opacity: 1;\n}\n\n@supports (display: block) {\n  .more:focus-visible {\n    opacity: 0.7;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UsersPopover__container-fd1e8f`,
	"list-with-count": `UsersPopover__list-with-count-f8eafe`,
	"listWithCount": `UsersPopover__list-with-count-f8eafe`,
	"more": `UsersPopover__more-a0f0be`
};
module.exports = ___CSS_LOADER_EXPORT___;
